import React, { useState } from "react"
import { Col, Row } from "reactstrap"
import { useParams } from "react-router-dom"
import toast from "react-hot-toast"

import eyeIcon from "../../../assets/images/icons/eye-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"

import ActiveInactiveSwitch from "../CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { Pagination } from "../../../components/Pagination"
import {
   UpdateTrailerEquipmentSequence,
   GetTrailerEquipmentItems,
   UpdateTrailerEquipmentItem,
   DeleteTrailerEquipmentItem,
   GetEquipmentsCategoryItemsListing,
} from "../../../api/api.service"
import { SearchBox } from "../../../components/SearchBox"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import {
   EquipmentCategoriesStatus,
   EquipmentCategoryItemsStatus,
} from "../../../constants"
import { convertToSelectOptions } from "../../../utils/commonUtils"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import DeleteModal from "../CommonUI/Modal/DeleteModal"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import useAsyncSelect from "hooks/useAsyncSelect"
import ManageImportGlobalEquipmentModal from "./ManageImportGlobalEquipmentModal"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"
import ManageEquipmentsCategoryItems from "./ManageEquipmentsCategoryItems"

const COLUMNS = {
   EQUIPMENT_NAME: "Equipment Name",
   PRICE: "Price",
   DATE_EDITED: "Date edited",
   STATUS: "Status",
   ACTIONS: "Actions",
}

const DATA_KEY = "data"
const TOTAL_KEY = "total"

const Equipment = ({}) => {
   const { trailerId } = useParams()
   const [statusFilters, setStatusFilters] = useState(null)
   const [selection, setSelection] = useState({})
   const [openDelModal, setOpenDelModal] = useState(false)
   const [selectedEquipment, setSelectedEquipment] = useState(null)
   const [openSelectEquipmentsModal, setOpenSelectEquipmentsModal] =
      useState(false)
   const [selectedEquipments, setSelectedEquipments] = useState([])
   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   // For Global Equipment Categories selection
   const {
      setSelectedOption: setSelectedGlobalEquipmentItemsOption,
      selectEntity: globalEquipmentsItemsOptions,
      setSelectEntity: setGlobalEquipmentsItemsOptions,
      handleSearchOnOptions: handleSearchGlobalEquipmentItems,
      selectedOption: selectedGlobalEquipmentItemsOption,
      handleSelectAOption: handleSelectAGlobalEquipmentItemsOption,
   } = useAsyncSelect({
      apiFunc: GetEquipmentsCategoryItemsListing,
      enabled: openSelectEquipmentsModal,
      labelKey: "name",
      valueKey: "id",
      restrictExecutionOnRender: false,
      onOptionSelect: option => {
         setSelectedEquipment(option)
      },
   })

   // For Local Equipments Items Listing

   const {
      data: equipmentItemsData,
      isFetching: equipmentItemsIsFetching,
      page: equipmentItemsPage,
      searchText: equipmentItemsSearchText,
      pageSize: equipmentItemsPageSize,
      total: equipmentItemsTotal,
      handleSearchChange: handleEquipmentItemsSearchChange,
      request: equipmentItemsRequest,
      handlePageClick: handleEquipmentItemsPageClick,
      onChangePageSize: handleEquipmentItemsChangePageSize,
      setTableDataChangeLoading: setEquipmentItemsTableDataChangeLoading,
      tableDataChangeLoading: equipmentItemsTableDataChangeLoading,
      setData: setEquipmentItemsData,
   } = useLocalPaginatedRequest({
      requestFn: GetTrailerEquipmentItems,
      customParams: {
         trailerId: Number(trailerId),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === EquipmentCategoryItemsStatus.Active
            ? EquipmentCategoryItemsStatus.Inactive
            : EquipmentCategoryItemsStatus.Active
      let dataClone = [...equipmentItemsData]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setEquipmentItemsData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setEquipmentItemsTableDataChangeLoading(true)
         await UpdateTrailerEquipmentItem(id, payload)
         toast.success("Item status has been updated !")
      } catch (err) {
         toast.error(err.message)
         let dataClone = [...equipmentItemsData]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setEquipmentItemsData(dataClone)
      } finally {
         setEquipmentItemsTableDataChangeLoading(false)
      }
   }
   const handleInitDelete = obj => {
      setSelection(obj)
      setOpenDelModal(prev => !prev)
   }

   const handleInitViewDetails = (obj = null) => {
      setSelection(obj)
      setEventsType(prev => ({ ...prev, isDetails: true, isManage: true }))
   }

   return (
      <>
         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-end admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <Button
                  className={`header-button headerButtonResponsive global-selection-button`}
                  title="Select Equipment(s)"
                  onClick={() => setOpenSelectEquipmentsModal(true)}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(EquipmentCategoriesStatus)}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="custom-input-search-icon"
                     conClass={`search-input-container-class`}
                     searchText={equipmentItemsSearchText}
                     onChange={handleEquipmentItemsSearchChange}
                  />
               </div>
            </div>
         </div>
         <Row>
            <Col md={12}>
               <DataTable
                  data={equipmentItemsData}
                  tableClasses="equipment-category-table"
                  loading={equipmentItemsIsFetching}
                  config={[
                     {
                        title: COLUMNS.EQUIPMENT_NAME,
                        className: "",
                        render: data => (
                           <TruncatedTextWithTooltip text={data.name} />
                        ),
                     },
                     {
                        title: COLUMNS.PRICE,
                        className: "",
                        render: data => "$" + data?.price || "-",
                     },
                     {
                        title: COLUMNS.DATE_EDITED,
                        className: "",
                        render: data => {
                           return convertDateTime({
                              date: data.updatedAt,
                              customFormat:
                                 dateTimeFormat.casitaCustomDateFormat,
                              dateOnly: true,
                              local: true,
                           })
                        },
                     },

                     {
                        title: COLUMNS.STATUS,
                        className: "",
                        render: data => (
                           <ActiveInactiveSwitch
                              isDisable={true}
                              id={data.id}
                              name={`${data.id}`}
                              onChange={e =>
                                 handleStatusChange(data?.status, data?.id)
                              }
                              isChecked={
                                 data?.status ==
                                 EquipmentCategoryItemsStatus.Active
                              }
                           />
                        ),
                     },

                     {
                        title: COLUMNS.ACTIONS,

                        render: data => (
                           <div className="d-flex gap-2 pointer">
                              <img
                                 src={eyeIcon}
                                 onClick={() => handleInitViewDetails(data)}
                              />

                              <img
                                 src={DeleteIcon}
                                 onClick={() => handleInitDelete(data)}
                              />
                           </div>
                        ),
                     },
                  ]}
               />
            </Col>
            <Pagination
               currentPage={equipmentItemsPage}
               totalData={equipmentItemsTotal}
               onPageClick={handleEquipmentItemsPageClick}
               rowLimit={equipmentItemsPageSize}
               onChangePageSize={handleEquipmentItemsChangePageSize}
            />
         </Row>

         <ManageImportGlobalEquipmentModal
            isOpen={openSelectEquipmentsModal}
            onToggleModal={() => {
               setOpenSelectEquipmentsModal(false)
               setSelectedEquipments([])
            }}
            equipmentsOptions={globalEquipmentsItemsOptions}
            setEquipmentsOptions={setGlobalEquipmentsItemsOptions}
            handleSearchEquipment={handleSearchGlobalEquipmentItems}
            selectedEquipments={selectedGlobalEquipmentItemsOption}
            setSelectedEquipments={setSelectedGlobalEquipmentItemsOption}
            trailerId={trailerId}
            onSuccess={equipmentItemsRequest}
            existingTrailerEquipments={equipmentItemsData || []}
         />

         {Object.values(eventsType).includes(true) && (
            <ManageEquipmentsCategoryItems
               isUpdating={Boolean(eventsType.isManage && selection)}
               isDetailView={eventsType.isDetails}
               isOpen={eventsType.isManage}
               id={
                  selection?.configuratorEquipmentSubTypePropertyId ||
                  selection?.id
               }
               onSuccess={equipmentItemsRequest}
               onToggleModal={() => {
                  setSelection(null)
                  setEventsType(prev => ({
                     ...prev,
                     isManage: false,
                     isDetails: false,
                  }))
               }}
            />
         )}
         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={selection?.id}
            apiFunction={DeleteTrailerEquipmentItem}
            title={"Equipment Item"}
            requestFunction={equipmentItemsRequest}
         />
      </>
   )
}

export default Equipment
